/*
 * @Descripttion: 产品导航
 * @Author: huangfuchunmei
 * @Date: 2023-08-29 15:56:48
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-09-19 17:59:03
 */
import React, { useEffect } from "react";
import BuyButton from "@/components/BuyButton";
import LazyMedia from "@/components/LazyMedia";
import styles from "./index.module.scss";
import { bannerPositon } from '@/common/const';
import { IBanner } from "@/common/types";
import loadable from 'react-loadable'
import NoSSR from 'react-no-ssr';

const CustomSwiper = loadable({
  loader: () => import('@/components/CustomSwiper'),
  loading: () => <div></div>,
})

interface ProductProps {
  productPreviewList: IBanner[]; // 首页banner2数据
  ctry?: string;
  words: Record<string, string>;
  device: string;
}

const ProductPreview: React.FC<ProductProps> = ({
  productPreviewList,
  words,
  device,
}) => {

  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)
  const defaultPositon: Record<string, Record<string, number>> = bannerPositon // 文字和按钮默认位置
  // 获取swiper实例 处理鼠标enter/leave时暂停/播放
  const [swiper, setSwiper] = React.useState<any>(null)
  useEffect(() => {
    if (swiper) {
      const swiperDom = swiper.$el[0]
      swiperDom.addEventListener('mouseenter', () => swiper.autoplay.stop())
      swiperDom.addEventListener('mouseleave', () => swiper.autoplay.start())
    }
  }, [swiper])
  return (
    <>
      {productPreviewList && (
        <div className={styles["product-preview-slider-wrap"]}>
          <NoSSR>
            <CustomSwiper
              loop={true}
              spaceBetween={24}
              centeredSlides={true}
              swiperSlideClass={styles["custom-swiper-slider"]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              setSwiper={setSwiper}
              isShowNavigation={true}>
              {productPreviewList?.map((item: IBanner) => (
                <div className={styles["slider-item"]} key={item.id}>
                  {
                    item[newDevice].extension === '.mp4'
                    ? <LazyMedia type="video" loop autoPlay preload="auto" playsInline muted src={item[newDevice]?.url}></LazyMedia>
                    : <LazyMedia type="image" src={item[newDevice]?.url} alt={item[newDevice]?.alt} />
                  }

                  <div className={styles["slider-item-content-wrap"]}>
                    <div className={styles["title-wrap"]}
                        style={{
                      left: item[newDevice]?.titleLeft ? item[newDevice]?.titleLeft+'%' : defaultPositon[newDevice]?.titleLeft+'%',
                      top: item[newDevice]?.titleTop ? item[newDevice]?.titleTop+'%' : defaultPositon[newDevice]?.titleTop+'%'
                    }}>
                      {item?.isShowTitle === 1 && (
                        <h2>{item?.name}</h2>
                      )}
                      <h4 className="preLine">{item?.remark}</h4>
                    </div>
                    <div className={styles["btn-wrap"]}
                        style={{
                          left: item[newDevice]?.btnLeft ? item[newDevice]?.btnLeft+'%' : defaultPositon[newDevice]?.btnLeft+'%',
                          top: item[newDevice]?.btnTop ? item[newDevice]?.btnTop+'%' : defaultPositon[newDevice]?.btnTop+'%'
                        }}>
                      <div className={styles["btn-group"]}>
                        <BuyButton buyPaths={item?.buyPaths} words={words} btnStyle={item[newDevice]?.btnStyle} />
                        {item && item.url && (
                            <span
                                className={styles["learn-more"]}
                                onClick={() => {
                                  window.open(item.url);
                                }}
                            >
                          {words?.common_learn_more}
                        </span>
                        )}
                      </div>
                    </div>

                  </div>
                </div>
              ))}
            </CustomSwiper>
          </NoSSR>
        </div>
      )}
    </>
  );
};

export default ProductPreview;
